<!-- 库存盘点 -->
<template>
  <div class="app-container">
    <div>
      <el-button type="primary" @click="handleAdd">发起库存盘点</el-button>
    </div>
    <el-scrollbar
      v-loading="fullscreenLoading"
      ref="scrollbarRef"
      :height="scrollbar_height"
      @scroll="handleScroll"
    >
      <el-row :gutter="8" class="mt10">
        <el-col :span="4" v-if="warehouseList.length > 1">
          <el-select
            v-model="formData.warehouse"
            filterable
            clearable
            placeholder="请选择仓库名称"
          >
            <el-option
              v-for="subItem in warehouseList"
              :key="subItem.warehouseId"
              :label="subItem.warehouseName"
              :value="subItem.warehouseId"
            />
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select
            v-model="formData.checkInventoryRecordType"
            filterable
            clearable
            placeholder="请选择盘点类型"
          >
            <el-option
              v-for="subItem in getDictListByParentCode(
                'checkInventoryRecordType'
              )"
              :key="subItem.libraryCode"
              :label="subItem.libraryName"
              :value="subItem.libraryCode"
            />
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" icon="Search" @click="handleQuery"
            >搜索</el-button
          >
          <el-button icon="Refresh" @click="resetQuery">重置</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="8" class="checkInventoryCard">
        <el-col
          :span="8"
          v-for="item in tableData"
          :key="item.checkInventoryRecordId"
        >
          <el-card
            class="cardContainer"
            :class="item.checkInventoryRecordType"
            @click="toDetail(item)"
            style="min-width: 500px"
            shadow="hover"
          >
            <template #header>
              <div class="checkHeader">
                <div class="checkName">
                  <svg-icon
                    class-name="checkInventory"
                    icon-class="checkInventory"
                  />
                  {{ item.checkInventoryRecordName }}
                </div>
                <div
                  :class="item.status == '0' ? 'checkStatus' : 'checkStatusEnd'"
                  class="showBtn"
                >
                  {{ statusFilter(item.status) }}
                </div>
                <div class="btnClass">
                  <el-button
                    type="primary"
                    :disabled="item.checkFlag == '1' || item.status == '1'"
                    @click.stop="handleCheckEnd(item)"
                    >盘库结束</el-button
                  >
                </div>
              </div>
            </template>
            <div class="OutInInventory checkTitle mt10">
              {{ item.warehouseName }}
            </div>
            <el-row class="OutInInventory mt5">
              <el-col :span="16"
                ><span>库存总量：</span>{{ item.inventoryTotal }}</el-col
              >
              <el-col :span="8"
                ><span>入库总量：</span> {{ item.inInventoryTotal }}</el-col
              >
              <!-- <el-col :span="12"><span>所属仓库：</span> {{ item.warehouseName }}</el-col> -->
            </el-row>
            <el-row class="OutInInventory">
              <el-col :span="16"
                ><span>开始时间：</span>{{ item.startTime }}</el-col
              >
              <el-col :span="8"
                ><span>出库总量：</span>{{ item.outInventoryTotal }}</el-col
              >
            </el-row>
            <el-row class="OutInInventory">
              <el-col :span="16"
                ><span>结束时间：</span>{{ item.endTime }}</el-col
              >
            </el-row>
            <!-- <div class="OutInInventory">
                    <span>状态：</span>
                </div> -->
          </el-card>
        </el-col>
      </el-row>
    </el-scrollbar>

    <!-- 添加盘库记录 -->
    <el-dialog
      title="新增盘库记录"
      v-model="dialogOpen"
      width="600px"
      append-to-body
    >
      <el-form
        ref="dateFormRef"
        :model="dateForm"
        :rules="dateRules"
        label-width="120px"
      >
        <el-row>
          <el-col :span="24">
            <el-row>
              <el-col :span="12">
                <el-form-item label="盘库名称" prop="checkInventoryRecordName">
                  <el-input
                    v-model="dateForm.checkInventoryRecordName"
                    placeholder="请输入盘库名称"
                    maxlength="30"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="所属仓库" prop="warehouse">
                  <el-select v-model="dateForm.warehouse">
                    <el-option
                      v-for="item in searchOptions"
                      :key="item.warehouseId"
                      :label="item.warehouseName"
                      :value="item.warehouseId"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="开始时间" prop="startTime">
                  <el-date-picker
                    v-model="dateForm.startTime"
                    type="date"
                    format="YYYY/MM/DD"
                    value-format="YYYY-MM-DD"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="结束时间" prop="endTime">
                  <el-date-picker
                    v-model="dateForm.endTime"
                    type="date"
                    format="YYYY/MM/DD"
                    value-format="YYYY-MM-DD"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="备注">
                  <el-input
                    v-model="dateForm.systemName"
                    placeholder="请输入备注"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="closed">{{
            $t("msg.universal.cancel")
          }}</el-button>
          <el-button
            type="primary"
            @click="onConfirm"
            :disabled="saveDataFlag"
            >{{
              saveDataFlag ? "保存中" : $t("msg.universal.confirm")
            }}</el-button
          >
        </span>
      </template>
    </el-dialog>
    <!-- 盘库结束 -->
    <el-dialog
      title="盘点异常"
      v-model="dialogOpenEnd"
      width="1200px"
      append-to-body
    >
      <Table
        ref="tableRefDialogErr"
        :showSearchIcon="true"
        :data="tableDataDialogEnd"
        :columns="columnsDialog"
        :total="totalDialog"
        :loading="loadingDialog"
        rowKey="checkInventoryProductRecordId"
        @onSearch="selectEndDate"
      >
      </Table>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="closedEnd">关闭</el-button>
          <el-button type="primary" @click="handleCheckEndConfirm"
            >确认</el-button
          >
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import Table from "@/components/Element/Table";
import { ref, onMounted, reactive, watch } from "vue";
import { getCustomTableCols } from "@/tableColumn";
import {
  selectCheckInventoryRecord,
  insertCustomCheckInventoryRecord,
  selectMainCheckError,
  checkEnd,
  selectOtherCheckError,
} from "@/api/checkInventory";

import { useRouter } from "vue-router";
import { listWarehouse } from "@/api/warehouse/warehouse";
import useCacheStore from "@/store/modules/cache";
import { errorMsg, succesMsg } from "@/utils/msgBox";
import useInventoryStore from "@/store/modules/inventory";
const inventoryStore = useInventoryStore();
const cacheStore = useCacheStore();
const { getWarehouseNameById, getDictListByParentCode } = cacheStore;
const warehouseList = cacheStore.warehouse;
const router = useRouter();

/**仅支持 Vue 3.3+  配置name 为了是 keep-alive :include 生效 */
//   defineOptions({
//     name: "checkInventoryRecord",
//   });
const state = reactive({
  loading: false,
  _scrollTop: 0,
});
const scrollbar_height = ref("calc(100vh - 150px)");
const tableData = ref([]);
const loading = ref(false);
const fullscreenLoading = ref(false);
const searchOptions = ref();
const pageIndex = ref(1);
const pageSize = ref(15);
const formData = ref({});
const tableDataDialogEnd = ref([]);
const totalDialog = ref(0);
const loadingDialog = ref(false);
const searchMethod = () => {
  listWarehouse()
    .then((resData) => {
      searchOptions.value = resData.data;
      // curTotal.value = resData.pageParam.totleInfo
    })
    .finally(() => {
      // searchLoading.value = false
    });
};
const scrollbarRef = ref(null);
const handleScroll = ({ scrollTop }) => {
  let wrapRef = scrollbarRef.value.wrapRef;
  scrollbarRef.value.moveY = (wrapRef.scrollTop * 100) / wrapRef.clientHeight;
  scrollbarRef.value.moveX = (wrapRef.scrollLeft * 100) / wrapRef.clientWidth;
  let poor = wrapRef.scrollHeight - wrapRef.clientHeight;
  if (scrollTop + 2 >= poor) {
    state._scrollTop = scrollTop;
    pageIndex.value++;
    // emits("loadData", true)
    handleSearch();
  }
};
onMounted(() => {
  searchMethod();
  handleSearch();
});
watch(
  () => inventoryStore.checkInventoryStatus,
  (newVal) => {
    if (newVal === "1") {
      tableData.value = [];
      pageIndex.value = 1;
      pageSize.value = 15;
      handleSearch();
    }
  }
);
const statusFilter = (val) => {
  switch (val) {
    case "0":
      return "盘库进行中";
      break;
    default:
      return "盘库结束";
      break;
  }
};
const handleSearch = () => {
  sessionStorage.setItem("checkInventoryStatus", "");
  let whereSql = null;
  if (Object.keys(formData.value).length > 0) {
    let arr = [];
    for (let key in formData.value) {
      let obj = {
        column: key,
        querLogic: "like",
        value: formData.value[key],
      };
      arr.push(obj);
    }
    whereSql = JSON.stringify(arr);
  }
  fullscreenLoading.value = true;
  selectCheckInventoryRecord({
    pageIndex: pageIndex.value,
    pageSize: pageSize.value,
    whereSql: whereSql,
  })
    .then((res) => {
      // let arr = []
      res.data?.forEach((item) => {
        item.warehouseName = getWarehouseNameById(item.warehouse);
      });
      tableData.value = tableData.value.concat(res.data);
      // total.value = res?.pageParam?.totleInfo ? res.pageParam.totleInfo : 0;
    })
    .catch(() => {})
    .finally(() => {
      fullscreenLoading.value = false;
    });
};
const resetQuery = () => {
  pageIndex.value = 1;
  pageSize.value = 15;
  formData.value = {};
  tableData.value = [];
  handleSearch();
};
const handleQuery = () => {
  pageIndex.value = 1;
  pageSize.value = 15;
  tableData.value = [];
  handleSearch();
};
const dialogOpen = ref(false);
const dialogOpenEnd = ref(false);
const dateForm = ref();
const dateFormRef = ref(null);
const handleAdd = () => {
  dateForm.value = {};
  dialogOpen.value = true;
};

// 新增盘库记录表单规则
const dateRules = {
  checkInventoryRecordName: [
    { required: true, trigger: "blur", message: "盘库名称不能为空" },
  ],
  warehouse: [{ required: true, trigger: "blur", message: "所属仓库不能为空" }],
  startTime: [{ required: true, trigger: "blur", message: "开始不能为空" }],
  endTime: [{ required: true, trigger: "blur", message: "开始不能为空" }],
};
// 保存数据标志
const saveDataFlag = ref(false);

// 关闭
const closed = () => {
  dialogOpen.value = false;
};
// 提交
const onConfirm = () => {
  dateFormRef.value.validate((valid) => {
    if (!valid) return;
    dateForm.value.startTime = dateForm.value.startTime + " 00:00:00";
    dateForm.value.endTime = dateForm.value.endTime + " 23:59:59";
    saveDataFlag.value = true;
    insertCustomCheckInventoryRecord(dateForm.value)
      .then((resData) => {
        if (resData.status === 1) {
          closed();
          pageIndex.value = 1;
          pageSize.value = 15;
          formData.value = {};
          tableData.value = [];
          handleSearch();
        }
      })
      .finally(() => {
        saveDataFlag.value = false;
      });
  });
};
const toDetail = (item) => {
  router.push({
    path: "/checkInventory/checkInventoryMenu",
    query: { data: JSON.stringify(item) },
  });
};
const addEqptDialogOpen = ref();
const checkInventoryRecordId = ref("");
const handleCheckEnd = (val) => {
  checkInventoryRecordId.value = val.checkInventoryRecordId;
  selectOtherCheckError({
    checkInventoryRecordId: val.checkInventoryRecordId,
  }).then((res) => {
    if (res.data.length > 0) {
      errorMsg("存在未盘点辅材/耗材数据");
      return;
    } else {
      selectMainCheckError({
        checkInventoryRecordId: val.checkInventoryRecordId,
      }).then((res) => {
        if (res.data.length > 0) {
          // dialogTitle.value = '异常设备'
          dialogOpenEnd.value = true;
          tableDataDialogEnd.value = res.data;
        } else {
          checkEnd({ checkInventoryRecordId: val.checkInventoryRecordId })
            .then((res) => {
              succesMsg("盘点结束");
            })
            .catch((err) => {
              errorMsg(err.message);
            })
            .finally((data) => {
              resetQuery();
            });
        }
      });
    }
  });
};
const closedEnd = () => {
  dialogOpenEnd.value = false;
  checkInventoryRecordId.value = "";
  tableDataDialogEnd.value = [];
};
// 盘库结束存在异常数据后 确认
const handleCheckEndConfirm = () => {
  confirmBox("是否确定盘点结束，未盘点设备的状态都将改为丢失")
    .then(async () => {
      checkEnd({ checkInventoryRecordId: checkInventoryRecordId.value })
        .then((res) => {
          succesMsg("盘点结束");
        })
        .catch((err) => {
          errorMsg(err.message);
        })
        .finally((data) => {
          resetQuery();
        });
    })
    .catch((err) => {});
};
const selectEndDate = (data) => {
  selectMainCheckError({
    checkInventoryRecordId: checkInventoryRecordId.value,
    ...data,
  }).then((res) => {
    tableDataDialogEnd.value = res.data;
  });
};
const columnsDialog = getCustomTableCols([
  "eqptCode",
  "inventoryOperationType",
  "inventoryStatus",
  "inWarehouseTime",
  "outWarehouseTime",
  "status",
  "checkTime",
  "remarks",
  "operateTime",
  "operatorName",
]);
columnsDialog.splice(5, 0, {
  // 盘点状态
  label: "盘点状态",
  prop: "checkStatus",
  type: "select",
  dictKey: "checkStatus",
});
</script>

<style lang="scss" scoped>
.checkInventoryCard {
  display: flex;
  flex-wrap: wrap;
  .checkHeader {
    display: flex;
    justify-content: space-between;
    font-weight: bold;
    &:hover {
      .showBtn {
        opacity: 0;
      }
      .btnClass {
        display: block;
      }
    }
    .checkStatus {
      color: #ed064b;
    }
    .checkStatusEnd {
      color: #8f8a8b;
    }
    .showBtn {
      opacity: 1;
    }
    .btnClass {
      display: none;
      position: absolute;
      right: 8px;
      top: 4px;
    }
  }
  .cardContainer {
    margin: 20px;
    :deep(.el-card__header) {
      padding: 2px 10px;
      position: relative;
      cursor: pointer;
      // background-color: #eff7f9;
    }
    :deep(.el-card__body) {
      cursor: pointer;
    }
    .checkTitle {
      font-weight: bolder;
      text-align: center;
      color: #555 !important;
    }
    span {
      font-weight: bolder;
    }
    .OutInInventory {
      padding: 10px 0;
      color: #717171;
    }
  }
  .quarter {
    :deep(.el-card__header) {
      // padding: 2px 10px;
      background-color: #eff7f9;
    }
  }
  .month {
    :deep(.el-card__header) {
      // padding: 2px 10px;
      background-color: #d2daf5;
    }
  }
  .custom {
    :deep(.el-card__header) {
      // padding: 2px 10px;
      background-color: #fff8c8;
    }
  }
  .year {
    :deep(.el-card__header) {
      // padding: 2px 10px;
      background-color: #efe5e8;
    }
  }
}
</style>
